import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUpload } = FiIcons;

export default function ProcessDocumentCard() {
  return (
    <Link to="/process" className="block text-center bg-white rounded-lg shadow-sm border border-gray-200 p-12 hover:shadow-md transition-shadow">
      <div className="inline-block bg-blue-100 p-4 rounded-full mb-4">
        <SafeIcon icon={FiUpload} className="w-8 h-8 text-blue-600" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900">Process New Document</h2>
      <p className="text-gray-600 mt-1">
        Upload and rebrand a document with your professional brand
      </p>
    </Link>
  );
}